<template>
  <!--存为弹出框-->
  <el-dialog
    :visible.sync="saveTemplateVisible"
    title="存为模板"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthSaveTemplate"
  >
    <div class="container">
      <!-- 模板名称 start -->
      <el-row :gutter="10" style="margin-bottom: 50px">
        <el-col :span="4" style="margin-top: 2px">
          <span style="margin-top: 5px">模板名称</span>
        </el-col>

        <el-form label-position="top" size="mini" :model="ebOrderTemplate"
                 :validateOnRuleChange="false" ref="ruleFormRef" :rules="rulesForm">
          <el-col :span="20">
            <el-form-item prop="templateName">
              <el-input v-model="ebOrderTemplate.templateName"
                        :title="ebOrderTemplate.templateName"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <!-- 模板名称 end -->
      <!-- 按钮 start -->
      <el-row
        type="flex"
        justify="center"
        align="middle"
        :gutter="10"
        class="el-row-margin"
      >
        <el-button type="primary" size="small" plain @click="sure">存为模板</el-button>
        <el-button type="info" size="small" plain @click="close">取消</el-button>
      </el-row>
      <!-- 按钮 end -->
    </div>
  </el-dialog>
</template>

<script>
  import ebOrderTemplate from "@/api/ebOrderTemplate";
  import {saveEbOrderTemplate} from "@/api/bookingRequest";

  export default {
    name: 'saveTemplateUpBox',
    props: {
      saveTemplateVisibleFlagInit: Boolean,
      allBookingDTO: {}
    },
    data() {
      return {
        //非空校验
        rulesForm: {
          templateName: [{
            required: true,
            message: "【模板名称】不能为空",
            trigger: ['blur', 'change']
          }]
        },
        saveTemplateVisible: false,
        ebOrderTemplate: {
          templateName: ''
        }
      }
    },
    // 监听
    watch: {
      saveTemplateVisibleFlagInit() {
        let self = this
        self.saveTemplateVisible = true
      }
    },
    async created() {

    },
    mounted() {

    },
    methods: {
      //确认
      sure() {
        let self = this
        //非空校验
        self.$refs.ruleFormRef.validate(async valid => {
          if (valid) {
            ebOrderTemplate.queryEbOrderTemplateByTemplateName(self.ebOrderTemplate.templateName).then(res => {
              if (res.data.length > 0) {
                self.$coreMethods.confirm(
                  function () {
                    let ebOrderTemplate = res.data[0]
                    ebOrderTemplate.templateType = '00'
                    ebOrderTemplate.jsonInfo = JSON.stringify(self.allBookingDTO)
                    ebOrderTemplate.templateName = self.ebOrderTemplate.templateName
                    ebOrderTemplate.isActive = 1
                    ebOrderTemplate.isDeleted = 0
                    saveEbOrderTemplate(ebOrderTemplate).then(res => {
                      if (res.success) {
                        self.$coreMethods.message('success', '保存模板成功！')
                        self.saveTemplateVisible = false
                      } else {
                        self.$coreMethods.message('success', '保存模板失败！')
                      }
                    })
                  },
                  function () {
                    self.$emit('close')
                  },
                  false,
                  "",
                  self.$t('模板名称重复, 是否覆盖?'),
                  'error'
                )
              } else {
                let ebOrderTemplate = {
                  templateType: '00',
                  jsonInfo: JSON.stringify(self.allBookingDTO),
                  templateName: self.ebOrderTemplate.templateName,
                  isActive: 1,
                  isDeleted: 0
                }
                saveEbOrderTemplate(ebOrderTemplate).then(res => {
                  if (res.success) {
                    self.$coreMethods.message('success', '保存模板成功！')
                    self.saveTemplateVisible = false
                  } else {
                    self.$coreMethods.message('success', '保存模板失败！')
                  }
                })
              }
            })
          }
        })
      },
      //关闭
      close() {
        let self = this
        self.saveTemplateVisible = false
      }
    }
  }
</script>

<style>
  .customWidthSaveTemplate {
    width: 35%;
    height: 230px;
  }

  .el-dialog__body {
    padding: 0px;
  }

</style>
